<template>
  <div>
    <div class="main-content">
      <div> 单据信息 </div>
      <el-form :model="query" :rules="rules" ref="ruleForm">
        <div class="form-box">
          <el-form-item label="公司：" prop="companyCode">
            <el-select v-model="query.companyCode" placeholder="请选择公司" @change="changeCompany">
              <el-option
                v-for="item in companyList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="功能模块：" prop="modelCode">
            <el-select
              v-model="query.modelCode"
              placeholder="请选择功能模块"
              @change="modelChange"
              :disabled="modelList.length <= 0"
            >
              <el-option
                v-for="item in modelList"
                :label="item.modelName"
                :value="item.modelCode"
                :key="item.modelCode"
                :disabled="item.disabled"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="业务单据类型：" prop="entityCode">
            <el-select
              v-model="query.entityCode"
              placeholder="请选择业务单据"
              :disabled="entityNameList.length <= 0"
              @change="entityCodeChange"
            >
              <el-option
                v-for="item in entityNameList"
                :label="item.entityName"
                :value="item.entityCode"
                :key="item.entityCode"
                :disabled="item.disabled"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="管控节点：" prop="nodeCode">
            <el-select
              v-model="query.nodeCode"
              placeholder="请选择业务单据"
              :disabled="nodeNameList.length <= 0"
            >
              <el-option
                v-for="item in nodeNameList"
                :label="item.nodeName"
                :value="item.nodeCode"
                :key="item.nodeCode"
                :disabled="item.disabled"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="是否强管控：">
            <el-select v-model="query.isStrongControl">
              <el-option label="是" value="Y"></el-option>
              <el-option label="否" value="N"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="是否启用：">
            <el-select v-model="query.enableFlag">
              <el-option label="是" value="Y"></el-option>
              <el-option label="否" value="N"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="创建人：">
            <el-input v-model="query.createBy" disabled></el-input>
          </el-form-item>
          <el-form-item label="创建时间：">
            <el-input v-model="query.gmtCreate" disabled></el-input>
          </el-form-item>
        </div>
      </el-form>
      <div class="btn-item-detail">
        <a v-hasPermi="['2022010711163569117']" class="btn-save" @click="save()"
          ><svg-icon
            :class="{ 'icon-img-admin': true }"
            style="font-size: 14px"
            icon-class="icon-preserve"
          />保存</a
        >
      </div>
    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex';
  export default {
    name: 'edit',
    data() {
      return {
        query: {
          modelCode: '',
          companyCode: '',
          entityCode: '',
          companyName: '',
          modelName: '',
          createBy: '',
          gmtCreate: '',
          entityName: '',
          enableFlag: '',
          nodeName: '',
          isStrongControl: '',
          nodeCode: '',
        },
        companyList: [], //公司数组
        modelList: [], //总数居
        entityNameList: [], //业务单据
        nodeNameList: [], //管控节点
        rules: {
          companyCode: [{ required: true, message: '请选择公司', trigger: 'change' }],
          modelCode: [{ required: true, message: '请选择功能模块', trigger: 'change' }],
          entityCode: [{ required: true, message: '请选择业务单据类型', trigger: 'change' }],
          nodeCode: [{ required: true, message: '请选择管控节点', trigger: 'change' }],
        },
      };
    },
    mounted() {
      this.getCompany();
      this.loadDetail();
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo,
      }),
    },
    methods: {
      //获取公司信息
      getCompany() {
        this.$axios
          .get(
            `/maindata/company/listCompanyByTenantCode` + `/${this.userInfo.userInfo.tenantCode}`
          )
          .then((res) => {
            if (res.data.code == 0) {
              this.companyList = res.data.data;
            }
          });
      },
      changeCompany(val) {
        this.$axios
          .get('/sales/creditLimitEngine/getExistData', { companyCode: val })
          .then((res) => {
            if (res.data.code === 0) {
              this.modelList = res.data.data;
              if (this.$route.query && this.$route.query.type !== 'edit') return;
              this.loadDictList('modelList', this.query.modelCode, 'modelCode', 'entityNameList');
              this.loadDictList(
                'entityNameList',
                this.query.entityCode,
                'entityCode',
                'nodeNameList'
              );
            }
          });
      },
      modelChange(val) {
        //切换功能模块
        //清空业务单据
        this.query.entityCode = '';
        this.query.nodeCode = '';
        this.entityNameList = [];
        this.nodeNameList = [];
        this.loadDictList('modelList', val, 'modelCode', 'entityNameList');
      },
      entityCodeChange(val) {
        this.loadDictList('entityNameList', val, 'entityCode', 'nodeNameList');
      },
      loadDictList(item, val, key, list) {
        //item数组对象， val选中值， key选中值key, list赋值对象
        this[item].forEach((item) => {
          if (item[key] === val) {
            this[list] = item.children;
          }
        });
      },
      async loadDetail() {
        if (this.$route.query && this.$route.query.type !== 'edit') return;
        this.$axios
          .post('/sales/creditLimitEngine/getDetailById', { id: this.$route.query.id })
          .then((res) => {
            this.query = res.data.data;
            //当数据为编辑时，获取每个选项列表
            this.changeCompany(this.query.companyCode);
          });
      },
      save() {
        this.$refs['ruleForm'].validate((valid) => {
          if (valid) {
            this.query.companyName = this.filterName(this.query.companyCode, this.companyList);
            this.query.modelName = this.filterName(this.query.modelCode, this.modelList);
            this.query.entityName = this.filterName(this.query.entityCode, this.entityNameList);
            this.query.nodeName = this.filterName(this.query.nodeCode, this.nodeNameList);
            this.$axios.post('/sales/creditLimitEngine/save', this.query).then((res) => {
              if (res.data.code === 4010) {
                this.$message({ showClose: true, message: res.data.msg, type: 'error' });
              } else if (res.data.code === 0) {
                this.$message({ showClose: true, message: '操作成功', type: 'success' });
              }
            });
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      filterName(val, list) {
        let label = '';
        list.forEach((item) => {
          if (item.value === val) label = item.label;
        });
        return label;
      },
    },
  };
</script>

<style scoped lang="scss">
  .form-box {
    display: flex;
    flex-wrap: wrap;
    .el-form-item {
      width: 320px;
      margin-left: 20px;
      margin-top: 18px;
      ::v-deep .el-form-item__label {
        width: 110px;
      }
      ::v-deep .el-form-item__content {
        margin-left: 110px;
      }
      ::v-deep .el-select {
        width: 100%;
      }
    }
    .item {
      display: flex;
      flex-wrap: wrap;
    }
  }

  .btn-item-detail {
    text-align: center;
  }
</style>
